/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';

interface BvInlineErrorSignature {
  Args: {
    dataTestInlineError?: string;
    dataTestInlineErrorIcon?: string;
    fieldID?: string;
    hideIcon?: boolean;
    isWarning?: boolean;
    message?: ContentValue;
  };
  Element: HTMLDivElement;
}

const BvInlineErrorComponent = templateOnlyComponent<BvInlineErrorSignature>();

export default BvInlineErrorComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvInlineError: typeof BvInlineErrorComponent;
    'bv-inline-error': typeof BvInlineErrorComponent;
  }
}
